import * as React from 'react';
import NumberFormat from 'react-number-format';
import { TextField } from '@stadline/react-ui-components';

const PhoneField = props => (
  <NumberFormat customInput={TextField} format="## ## ## ## ##" {...props} />
);

export default PhoneField;
